import { useMemo } from 'react';

import { TaxRate } from '@dreryk/egabinet-private-medical-service-frontend-api';

import {
   Bean,
   commonTranslationKeys,
   createTranslatedText,
   FieldControllerProps,
   ValidationRules,
} from '@dreryk/react-common';
import { Select, StyledMaxWidth } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

const triggerLabelExtractor = (item: TaxRate): string => item.name;

type MedicalServiceTaxRateFieldProps = FieldControllerProps<'taxRate', TaxRate | null> & {
   readonly taxRates: TaxRate[];
   readonly disabled?: boolean;
};

export const MedicalServiceTaxRateField = (props: MedicalServiceTaxRateFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: props.required,
      };
   }, [props.required]);

   return (
      <StyledMaxWidth maxWidth={133}>
         <Select<TaxRate>
            testId={props.name}
            triggerLabelExtractor={triggerLabelExtractor}
            controller={props.register(props.name, validationRules)}
            label={medicalServiceTranslationKeys.shared.taxRate.field.label}
            placeholder={commonTranslationKeys.choose}
            maxHeight={190}
            disabled={props.disabled}
         >
            <Select.List<TaxRate> items={props.taxRates} keyExtractor={'id'}>
               {(taxRate) => (
                  <Select.Item testId={taxRate.id} item={taxRate} label={createTranslatedText(taxRate.name)} />
               )}
            </Select.List>
         </Select>
      </StyledMaxWidth>
   );
};
